module.exports = __webpack_public_path__ + "img/home_gif_mp4.2b0d1468.gif";